/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_DescriptionInputs */

const es_settings_files_description = /** @type {(inputs: Settings_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscá, filtrá y administrá todos los archivos ingestados de tus proveedores.`)
};

const en_settings_files_description = /** @type {(inputs: Settings_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search, filter and manage all ingested files across providers.`)
};

/**
* | output |
* | --- |
* | "Search, filter and manage all ingested files across providers." |
*
* @param {Settings_Files_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_description = /** @type {((inputs?: Settings_Files_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_description(inputs)
	return en_settings_files_description(inputs)
});
export { settings_files_description as "settings.files.description" }